import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Page } from "src/app/model/Page";
import { NocApproverListModel } from "src/app/model/NocApproverListModel";
import { NocApproverService } from "src/app/services/noc-approver.service";

@Component({
  selector: "app-secure-pro-approver-list",
  templateUrl: "./noc-approver-list.component.html",
  styleUrls: ["./noc-approver-list.component.scss"],
})
export class NocApproverListComponent implements OnInit, AfterViewInit {
  nocApproverList: Page<NocApproverListModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<NocApproverListModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "pan",
    "schemeCode",
    "applicantName",
    "updatedOn",
    "nocStatus",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  nocStatusList: string[] = ["PENDING", "APPROVED", "REJECTED" , "CANCELLED","CANCEL_REQUESTED"];

  constructor(
    private router: Router,
    private nocApproverService: NocApproverService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.minLength(3)]),
      nocStatus: new FormControl("PENDING", [Validators.required]),
    });
    this.loadData();
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.loadData();
    }
    else {
      this._snackBar.open("Please Select Verification Status", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.filterForm.controls['nocStatus'].setValue("PENDING");
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    console.log('this.filterForm.value', this.filterForm.value, this.filterForm.value?.filterText, 
    this.filterForm.value?.filterText !== undefined);
    this.nocApproverService.fetchNocApproverList(this.currentPage, this.pageSize, 
      (this.filterForm.value?.filterText != undefined ? 
      this.filterForm.value?.filterText
      : null), this.filterForm.value?.nocStatus
      ).subscribe((page) => {
        this.isLoading = false;
        console.log(page);
        this.nocApproverList = page;
        this.dataSource = new MatTableDataSource(page.content);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = page.totalElements;
        });
        this.isSearchDisabled = false;
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  showVerificationStatus(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  viewClassForVerificationStatus(moderationStatus: string) {
    if(moderationStatus === 'PENDING') {
        return 'bg-blue-400';
    }
    else if(moderationStatus === 'APPROVED') {
        return 'bg-green-400';
    }
    else if(moderationStatus === 'REJECTED') {
        return 'bg-pink-600';
    }
    else if(moderationStatus === 'CANCELLED') {
      return 'bg-red-600';
    }
    else if(moderationStatus === 'CANCEL_REQUESTED') {
      return 'bg-orange-600';
    }
    else {
        return '';
    }
  }
}